// libraries
import { useState, createContext, useEffect } from "react";
import firebase from "../firebase/firebase";

// helpers
import { approvedRecipes, recommendedRecipes } from "../utils/helpers";

// create context
const RecipesContext = createContext();

// firestore
const recipesDocument = firebase.firestore().collection("recipes");

export const RecipesProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [recipes, setRecipes] = useState([]);
  const [allRecipes, setAllRecipes] = useState([]);
  const [recommended, setRecommended] = useState([]);

  // Initializing FireStore User Document
  useEffect(() => {
    var arr = [];
    setLoading(true);
    recipesDocument.onSnapshot((snapshot) => {
      arr = snapshot.docs.map((doc) => doc.data());
      setAllRecipes(arr);
      const approved = approvedRecipes(arr);
      const recommended = recommendedRecipes(approved);
      setRecipes(approved);
      setRecommended(recommended);
      setLoading(false);
    });
  }, []);

  return (
    <RecipesContext.Provider
      value={{
        recipes,
        recommended,
        loading,
        setLoading,
        allRecipes,
      }}
    >
      {children}
    </RecipesContext.Provider>
  );
};

export default RecipesContext;
